'use strict'
import store from '../store'

function getToken() {
  return store.getters['mobile/mobileToken'] || ''
}

const service = process.env.VUE_APP_service_licenze || ''

const elencoScontriniPerData = async function (base, da, a, limit = 50, istanzaDb) {
  try {
    const data = {
      base,
      da,
      a,
      limit,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/scontrini/elenco/data`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('elencoScontriniPerData', err)
  }
}

const creaScontrino = async function (base, dati, parcheggio, istanzaDb) {
  try {
    const data = {
      base,
      dati,
      parcheggio,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/scontrini/crea`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('creaScontrino', err)
  }
}

const addRigaScontrino = async function (base, idScontrino, riga, istanzaDb) {
  try {
    const data = {
      base,
      idScontrino,
      riga,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/scontrini/addriga`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('addRigaScontrino', err)
  }
}

const updateScontrino = async function (base, idScontrino, righe, istanzaDb) {
  try {
    const data = {
      base,
      idScontrino,
      righe,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/scontrini/aggiorna`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('updateScontrino', err)
  }
}

const getParcheggiati = async function (base, istanzaDb) {
  try {
    const data = {
      base,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/scontrini/parcheggiati`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('getParcheggiati', err)
  }
}

const annullaParcheggio = async function (base, idScontrino, istanzaDb) {
  try {
    const data = {
      base,
      idScontrino,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/scontrini/parcheggiati/annulla`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('annullaParcheggio', err)
  }
}

export default {
  elencoScontriniPerData,
  creaScontrino,
  addRigaScontrino,
  updateScontrino,
  getParcheggiati,
  annullaParcheggio
}
